import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Label } from '@/components/ui/label'

interface CayuKeysSelectorProps {
  onUseCayuKeysChange: (useCayuKeys: boolean) => void
}

export function CayuKeysSelector({ onUseCayuKeysChange }: CayuKeysSelectorProps) {
  const { t } = useTranslation('conversations')
  const [useCayuKeys, setUseCayuKeys] = useState(false)

  const handleChange = (checked: boolean) => {
    setUseCayuKeys(checked)
    onUseCayuKeysChange(checked)
  }

  return (
    <div className="mb-4">
      <div className="flex items-center gap-3">
        <input
          type="checkbox"
          id="useCayuKeys"
          checked={useCayuKeys}
          onChange={(e) => handleChange(e.target.checked)}
          className="w-4 h-4 rounded border-input text-primary focus:ring-2 focus:ring-primary"
        />
        <Label htmlFor="useCayuKeys" className="text-sm font-medium cursor-pointer">
          {t('integrations.cayuKeys.selectorLabel')}
        </Label>
      </div>
    </div>
  )
}
